const MIN_MS = 60_000;
const HOUR_MS = 60 * MIN_MS;
const DAY_MS = 24 * HOUR_MS;
const WEEK_MS = 7 * DAY_MS;

/**
 * Format a timestamp as a human recency signal (F065 #42): "agora",
 * "há 10 minutos", "ontem", "há 3 dias" — falling back to the plain local
 * date past 7 days, where relative wording stops adding information.
 *
 * Pure: `now` is injectable for tests. Locale strings come from
 * `Intl.RelativeTimeFormat` (native pt-BR/pt-PT support — no i18n keys).
 * Small future timestamps (client/server clock skew) clamp to "now".
 */
export function formatRelativeTime(
  iso: string | null,
  lang: string,
  now: Date = new Date()
): string {
  if (!iso) return '—';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;

  const diffMs = Math.max(0, now.getTime() - date.getTime());
  if (diffMs >= WEEK_MS) return date.toLocaleDateString(lang);

  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: 'auto' });
  if (diffMs < MIN_MS) return rtf.format(0, 'second');
  if (diffMs < HOUR_MS) return rtf.format(-Math.floor(diffMs / MIN_MS), 'minute');
  if (diffMs < DAY_MS) return rtf.format(-Math.floor(diffMs / HOUR_MS), 'hour');
  return rtf.format(-Math.floor(diffMs / DAY_MS), 'day');
}
